class SerializrType_json {
    serializer({ value: json }) {
        return json;
    }
    deserializer({ json }) {
        // return isEqual(oldValue, json) ? oldValue : json;
        return json;
    }
}
const obj = new SerializrType_json();
export function json() {
    return obj;
}
